<template>
<div>
  <div  class="v-header-contain">
    <div class="vlt-header-left">
      <div class="vlt-header-logo">
        <router-link :to="{ name: 'Home' }" aria-label="Home Link">
          <img class="logo" :src="logoIcon" alt="logo" id="logo"/>
        </router-link>
      </div>     

      <div class="clearfix"></div>
    </div>
    
    <HeaderRight
      class="vlt-header-right" />
    <div class="clearfix"></div>
  </div>
</div>
</template>

<script>
import App from '@/mixins/App';
import { EventBus } from '@/main';
import { mapGetters } from 'vuex';

export default {
  name: 'Header',
  props: [
    'notifyCategories'
  ],
  data () {
    return {
      categories: null,
      nuCinema: 'CINEMA',
      watchList: 'MYLIST',
      ticket: 'TICKETS',
      initialized: false,
      showHamburgerBtn: true,
      showSubscribePopup: false,
      menucategories: [],
      showMenu: false,
      deniedRoutes: [
        'Login',
        'Signup'
      ],
      mobileBrowser: false,
      showTicket: false,
      logoIcon: require('@/assets/icons/Sdg_dark theme.svg')
    }
  },
  computed: {
    ...mapGetters([
      'subscriberid'
    ])
  },
  created () {
    this.initialized = true;
    this.mobileBrowser = window.mobilecheck();
  },
  deactivated () {
    this.initialized = false;
  },
  components: {
    HeaderRight : () => import("@/components/Header/Right/HeaderRight.vue"),
    Menu : () => import("@/components/Header/Menu/Menu.vue")
  },
  mounted () {
    this.checkRoutes();
  },
  watch: {
    '$route'(to, from) {
      this.checkRoutes();
    }
  },
  methods: {
    checkRoutes () {
      let name = this.$route.name;
      if (name == 'Detail') {
        this.logoIcon = require('@/assets/icons/Back_white.svg')
        document.getElementById('logo').style.width = '30px';
        document.getElementById('logo').style.marginLeft = '5px';

      } else {
        this.logoIcon = require('@/assets/icons/Sdg_dark theme.svg')
        document.getElementById('logo').style.width = '55px';
        document.getElementById('logo').style.marginLeft = '5px';
      }
    },
    toggleTicketPopup (state) {
      this.showTicket = state;
    },
    toggleMenuCB (state) {
      this.showMenu = state;
      this.togglePageSticky(state);
    }
  },
  mixins: [ App ]
}
</script>

<style lang="scss">
.v-header-contain {
  padding: 5px 0;
  .vlt-header-left {
    float: left;
    margin-top: 5px;
  }
  .vlt-header-right {
    float: right;
    position: relative;
  }
}
 .vlt-header-logo {
  float: left;
}

.hamb-btn {
  padding-top: 5px;
  margin-left: 10px;
  display: none;
  float: right;
  img {
    width: 20px;
    cursor: pointer;
  }
}
.vlt-header-logo {
  display: inline-block;
  padding: 0 20px;
  cursor: pointer;
  img {
    width: 55px;
  }
}
.menu-title {
  color: #212121;	
  font-family: "HelveticaNeueMedium";	
  font-size: 18px;	  
  line-height: 27px;
  font-style: normal;
  opacity: .6;  	
  &:hover{
    font-weight: 500;
    opacity: 1;
  }
}
.nucinema-title{
  color: #000000;	
  font-family: "GothamRounded-Medium";
  font-style: normal;	
  font-size: 19px;  
  letter-spacing: 0.41px;	
  line-height: 26px;
  margin-top: 3px;
  font-weight: 300;
}
.nucinema-title:before {
  color: red;
  content: "NU";
  font-weight: bold;
  font-family: "HelveticaNeueMedium";	
}
.v-mobile-header-contain{
  background: transparent;
}
.menuActive{
  opacity: 1;
  // font-weight: 500;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 768px)
{
  // .menu-title{
  //   display: none;
  // }
  // .vlt-header-right{
  //   float: left;
  // }
  // .hamb-btn{
  //   display: none;
  // }
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .v-header-contain {
    // position: fixed;
    // top: 0;
    // width: 100%;
  }
  .hamb-btn {
    display: block;
  }
  .trapezoid{
    left: -10.5%;
  }
  .content-card {
    .tags {
      display: none;
    }
    .hover-effect{
      background: transparent;
    }
  }
} 

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .v-header-contain {
    .vlt-header-logo {
      display: inline-block;
      padding: 0 40px;
      cursor: pointer;
    }
    .vlt-header-right{
      margin-right: 5%;
    }
  }
} 
@media only screen 
  and (min-device-width: 768px) 
  and (max-device-width: 1024px) 
  and (-webkit-min-device-pixel-ratio: 1) {

}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {} 

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {} 

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .v-header-contain {
    .vlt-header-right{
      margin-right: 0%;
    }
  }
}
// 4k 
@media screen and (min-width: 1900px) {
  .vlt-header-logo {
    img{
      width: 20%;
    }
  }
   .v-header-contain {
    .vlt-header-right{
      margin-top: 0.5%;
    }
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue